import { AxiosInstance } from 'axios'
import { Localizations, MediaObject } from '../types'

export interface GetSpecialistArgs {
  locale: string
  slug: string
}

type ServiceDto = {
  id: number
  attributes: {
    name: string
    slug: string
  }
}

type SpecialtiesDto = {
  attributes: {
    name: string
  }
}

type Education = {
  id: number
  item: string
}

type Reel = {
  id: number
  link: string
  title: string
  video?: MediaObject
}

type Review = {
  id: number
  name: string
  stars: number
  text: string
  title: string | null
}

export type SpecialistDto = {
  data: {
    attributes: {
      localizations: Localizations
      name: string
      slug: string
      academic_degree: string
      blockquote: string
      education_list: Array<Education>
      order: number
      photo: MediaObject | null
      reels: Array<Reel>
      work_experience: string
      youtube_link: string | null
      services: {
        data: ServiceDto[]
      }
      specialties: {
        data: SpecialtiesDto[]
      }
      reviews: Array<Review>
    }
  }
}

export const getSpecialist = async (client: AxiosInstance, { slug, locale }: GetSpecialistArgs) => {
  const specsPath = `/specialists`
  const specsParams = {
    locale: locale,
    sort: { createdAt: 'desc' },
    populate: {
      fields: ['id'],
    },
    filters: {
      slug: {
        $eq: slug,
      },
    },
  }
  const specialistID = (
    await client.get<{
      data: { id: string }[]
    }>(specsPath, { params: specsParams })
  ).data.data[0].id
  const path = `/specialists/${specialistID}`
  const params = {
    locale,
    fields: ['name', 'slug', 'academic_degree', 'blockquote', 'order', 'work_experience', 'youtube_link'],
    populate: {
      localizations: {
        fields: ['locale', 'slug'],
      },
      education_list: {
        populate: '*',
      },
      photo: {
        populate: '*',
      },
      reels: {
        populate: '*',
      },
      services: {
        fields: ['name', 'slug'],
      },
      specialties: {
        fields: ['name'],
      },
      reviews: {
        populate: '*',
      },
    },
  }
  return (await client.get<SpecialistDto>(path, { params })).data.data.attributes
}
